<div class="main rtl">
    <div class="row">
        <div class="col-10">
            <mat-form-field class="example-full-width text-right w-100" appearance="fill">
                <mat-label class="iransans text-right ">جستجو کنید</mat-label>
                <input matInput placeholder="مثلا دیابت" class="iransans">
              </mat-form-field>
        </div>
        <div class="col-2 m-auto">
            <button mat-button (click)="onClose()">
                <mat-icon class="vertical-middle">arrow_back</mat-icon>
            </button>
        </div>
    </div>
    <div class="row my-2">
        <div class="iransans-bold text-center">
            مقاله را بر اساس حرف اول پیدا کنید
        </div>
    </div>
   <div class="row m-0">
    <div class="col-3" *ngFor="let item of alphabetList">
        <button mat-button class="alphabet-button">
            {{item}}
        </button>
    </div>
   </div>
</div>